module.exports = __webpack_public_path__ + "img/位图(3).04074d9d.png";